<div class="dialog-container">
  <h2 mat-dialog-title>{{data.isEditMode ? 'تعديل' : 'إضافة'}} خبير</h2>
  <div mat-dialog-content>
    <div class="form-group">
      <label for="" class="form-label">
        الخبير
        <span class="red">*</span>
      </label>
      <app-select [optionItems]="experts" [id]="'experts'" [placeholder]="'يرجي اختيار الخبراء'"
        [bindLabel]="'full_name'" [bindValue]="'id'" [initValues]="data.initExperts" 
        [appendTo]="null" [maxLength]="1" [readonly]="data.isEditMode"
        (selectedOptions)="setExperts($event)" (onScrollValues)="onScrollExpertOptions()"
        (updateOptions)="updateExperts($event)">
      </app-select>
    </div>

    <div class="form-group">
      <label for="" class="form-label">التخصصات المسندة</label>
      @for (specialization of data.specializations; track specialization.id; let i = $index) {
      <div class="specialization-group">
        <div class="specializations">
          <div class="item">
            <div class="checkBox-wrapper">
              <label class="checkbox-container">
                <input type="checkbox" (change)="onSpecializationChange($event, specialization.id)"
                  [id]="specialization.id" [checked]="data.specialization_ids.includes(specialization.id)">
                <span class="checkmark"> </span>
              </label>
              <span class="checkbox-label">{{specialization.name_ar}}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div mat-dialog-actions class="actions-single">
    <button class="btn btn-cancel center-btn" mat-dialog-close>إلغاء</button>
    <button class="btn btn-add center-btn" [mat-dialog-close]="data"
      [disabled]="!(data.expert_ids.length && data.specialization_ids.length)">{{data.isEditMode ? 'تعديل' : 'إضافة'}}</button>
  </div>
</div>
